import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M3.969 2.667h24.057c1.21 1.04 1.985 2.306 2.463 3.333H1.529c.47-1.022 1.238-2.288 2.44-3.333M1.529 26H30.47c-.471 1.022-1.239 2.288-2.44 3.333H3.969C2.768 28.288 2 27.023 1.53 26m20.91-6.125L16 8.72 9.56 19.875zm-1.732-1h-9.416L16 10.72z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "m16 23.208 6.44-11.155H9.56zm0-2-4.708-8.155h9.416z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagIsr = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagIsr_default = SvgFlagIsr;

export { FlagIsr_default as default };
